
import React from 'react';
import './Input.css';

const Input = ({
    label,
    type = 'text',
    name,
    value,
    onChange,
    placeholder,
    required = false,
    error,
    ...props
}) => {
    return (
        <div className="input-group">
            {label && <label className="input-label" htmlFor={name}>{label}</label>}
            <div className="input-wrapper">
                {props.prefix && <span className="input-prefix">{props.prefix}</span>}
                <input
                    id={name}
                    name={name}
                    type={type}
                    className={`input-field ${error ? 'input-error' : ''} ${props.prefix ? 'has-prefix' : ''}`}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    required={required}
                />
            </div>
            {error && <span className="input-error-msg">{error}</span>}
        </div>
    );
};

export default Input;
